export default __webpack_public_path__ + "static/media/not_available.02124247.svg";